import { StudioAdminPermission } from "src/@types/studio-admin";

export function hasStudioAdminPermission(
  permissions: StudioAdminPermission[] | null | undefined,
  permission: StudioAdminPermission,
) {
  if (permissions === null || permissions === undefined) return true;
  return permissions.includes(permission);
}
